/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { BaseFile } from './BaseFile';
import { DirectoryWithChildren } from './DirectoryWithChildren';
const FileTreeParser = /* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('type', [
    ['file', BaseFile],
    ['directory', DirectoryWithChildren],
]);
export const FileTree = FileTreeParser;
